module.exports = __webpack_public_path__ + "static/media/09-photos.b722cd28.png";